module.exports = __webpack_public_path__ + "static/media/2.39eb5236.png";